import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_PROVIDER_RESET = 'DELETE_PROVIDER_RESET';
export const DELETE_PROVIDER_LOADING = 'DELETE_PROVIDER_LOADING';
export const DELETE_PROVIDER_SUCCESS = 'DELETE_PROVIDER_SUCCESS';
export const DELETE_PROVIDER_REJECT = 'DELETE_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteProviderReset = () => ({ type: DELETE_PROVIDER_RESET });
export const deleteProviderLoading = () => ({ type: DELETE_PROVIDER_LOADING });
export const deleteProviderSuccess = (payload) => ({ type: DELETE_PROVIDER_SUCCESS, payload });
export const deleteProviderReject = (payload) => ({ type: DELETE_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteProviderRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        data,
    }, getState);
    return request(`/api/Providers/${data.id}`, options);
};